

(function(){

  const root =
    document.getElementById(
      'SpoiltProduct-' + window.SpoiltProductConfig.sectionId + ''
    );


  if (!root){

    return;

  }


  const form =
    root.querySelector(
      '.spoilt-product-form'
    );


  if (!form){

    return;

  }


  /* ==========================================================
     PRODUCT DATA
  ========================================================== */


  const variants =
    window.SpoiltProductConfig.variants;


  const productOptions =
    window.SpoiltProductConfig.options;

  const variantInventory = new Map(
    (window.SpoiltProductConfig.variantInventory || []).map(function(item){
      return [Number(item.id), item];
    })
  );

  const lowStockThreshold =
    Number(window.SpoiltProductConfig.lowStockThreshold) || 3;


  let selectedOptions = [];


  const variantInput =
    root.querySelector(
      '#SpoiltVariantId-' + window.SpoiltProductConfig.sectionId + ''
    );


  let currentVariant =
    variants.find(
      function(variant){

        return (
          variant.id ===
          Number(
            variantInput?.value
          )
        );

      }
    ) ||

    variants.find(
      function(variant){

        return variant.available;

      }
    ) ||

    variants[0];


  if (currentVariant){

    selectedOptions = [

      currentVariant.option1 || null,

      currentVariant.option2 || null,

      currentVariant.option3 || null

    ];

  }


  /* ==========================================================
     ELEMENTS
  ========================================================== */


  const quantityInput =
    root.querySelector(
      '#SpoiltQuantity-' + window.SpoiltProductConfig.sectionId + ''
    );


  const quantityDisplay =
    root.querySelector(
      '#SpoiltQtyDisplay-' + window.SpoiltProductConfig.sectionId + ''
    );


  const priceElement =
    root.querySelector(
      '#SpoiltPrice-' + window.SpoiltProductConfig.sectionId + ''
    );


  const comparePriceElement =
    root.querySelector(
      '#SpoiltComparePrice-' + window.SpoiltProductConfig.sectionId + ''
    );


  const saveElement =
    root.querySelector(
      '#SpoiltSave-' + window.SpoiltProductConfig.sectionId + ''
    );




  const addButton =
    root.querySelector(
      '#SpoiltAdd-' + window.SpoiltProductConfig.sectionId + ''
    );


  const buyButton =
    root.querySelector(
      '#SpoiltBuy-' + window.SpoiltProductConfig.sectionId + ''
    );


  const stickyBar =
    root.querySelector(
      '[data-sticky-buy]'
    );


  const stickyPrice =
    root.querySelector(
      '[data-sticky-price]'
    );


  const stickyAdd =
    root.querySelector(
      '[data-sticky-add]'
    );


  const stickyBuy =
    root.querySelector(
      '[data-sticky-buy-button]'
    );


  const stockLocation =
    (root.dataset.stockLocation || '').trim().toLowerCase();

  const stockIsOverseas =
    root.dataset.stockOverseas === 'true' || /overseas/i.test(stockLocation);

  const stockIsDhaka =
    !stockIsOverseas &&
    (root.dataset.stockDhaka === 'true' || /dhaka|ready stock|in stock/i.test(stockLocation));

  const hasStockLocation =
    stockIsDhaka || stockIsOverseas;

  const dispatchBar =
    root.querySelector('[data-dispatch-bar]');

  const dispatchCountdown =
    root.querySelector('[data-dispatch-countdown]');

  const dispatchPrefix =
    root.querySelector('[data-dispatch-prefix]');

  const dispatchSuffix =
    root.querySelector('[data-dispatch-suffix]');

  const deliveryOptions =
    root.querySelectorAll('[data-delivery-option]');

  const stockProperty =
    root.querySelector('[data-stock-property]');

  const deliveryWrap =
    root.querySelector('.spoilt-delivery');


  /* ==========================================================
     MONEY
  ========================================================== */


  const moneyFormat =
    root.dataset.moneyFormat ||
    window.SpoiltProductConfig.moneyFormat;


  function formatMoney(cents){

    if (
      window.Shopify &&
      typeof Shopify.formatMoney ===
        'function'
    ){

      return Shopify.formatMoney(
        cents,
        moneyFormat
      );

    }


    return new Intl.NumberFormat(
      window.SpoiltProductConfig.locale,
      {
        style:'currency',
        currency:window.SpoiltProductConfig.currency
      }
    ).format(
      Number(cents || 0) / 100
    );

  }


  /* ==========================================================
     VARIANT
  ========================================================== */


  function variantOption(
    variant,
    index
  ){

    return variant[
      'option' +
      (index + 1)
    ];

  }


  function findVariant(){

    return variants.find(
      function(variant){

        for (
          let i = 0;
          i < productOptions.length;
          i++
        ){

          if (
            variantOption(
              variant,
              i
            ) !==
            selectedOptions[i]
          ){

            return false;

          }

        }


        return true;

      }
    );

  }


  function valueIsAvailable(
    optionIndex,
    value
  ){

    return variants.some(
      function(variant){

        if (!variant.available){

          return false;

        }


        for (
          let i = 0;
          i < productOptions.length;
          i++
        ){

          if (
            i === optionIndex
          ){

            continue;

          }


          if (
            selectedOptions[i] &&
            variantOption(
              variant,
              i
            ) !==
            selectedOptions[i]
          ){

            return false;

          }

        }


        return (
          variantOption(
            variant,
            optionIndex
          ) === value
        );

      }
    );

  }


  /* ==========================================================
     REFRESH VARIANT OPTION UI
  ========================================================== */

  const gradeGrid = root.querySelector('[data-grade-grid]');
  const sizeGrid = root.querySelector('[data-size-grid]');

  const gradeOptionIndex =
    gradeGrid &&
    gradeGrid.dataset.hasGradeOption === 'true'
      ? Number(gradeGrid.dataset.optionIndex)
      : null;

  const sizeOptionIndex =
    sizeGrid &&
    sizeGrid.dataset.hasSizeOption === 'true'
      ? Number(sizeGrid.dataset.optionIndex)
      : null;

  function updateGradeUI(){

    if (!gradeGrid){
      return;
    }

    const selectedGrade =
      gradeOptionIndex !== null
        ? selectedOptions[gradeOptionIndex]
        : window.SpoiltProductConfig.gradeName;

    gradeGrid
      .querySelectorAll('[data-grade-button]')
      .forEach(function(button){

        const value =
          button.dataset.optionValue;

        let available =
          button.dataset.gradeAvailable === 'true';

        if (gradeOptionIndex !== null){
          available = valueIsAvailable(
            gradeOptionIndex,
            value
          );
        }

        const active =
          selectedGrade === value;

        button.classList.toggle(
          'is-active',
          active
        );
        button.setAttribute('aria-pressed', String(active));

        button.classList.toggle(
          'is-unavailable',
          !available
        );

        if (gradeOptionIndex !== null){
          button.disabled =
            !available && !active;
        }else{
          button.disabled =
            !active;
        }

      });

    const selectedLabel =
      root.querySelector('[data-grade-selected]');

    if (selectedLabel){
      selectedLabel.textContent =
        selectedGrade
          ? '— ' + selectedGrade
          : '';
    }

    const selectedValue =
      root.querySelector('[data-grade-value]');

    if (selectedValue){
      selectedValue.textContent =
        selectedGrade || '';
    }

  }

  function getVariantForOptionValue(
    optionIndex,
    value,
    allowCurrentCombination
  ){

    return variants.find(function(variant){

      if (!variant.available){
        return false;
      }

      if (
        variantOption(variant, optionIndex) !==
        value
      ){
        return false;
      }

      if (allowCurrentCombination === false){
        return true;
      }

      for (
        let i = 0;
        i < productOptions.length;
        i++
      ){

        if (i === optionIndex){
          continue;
        }

        if (
          selectedOptions[i] &&
          variantOption(variant, i) !==
            selectedOptions[i]
        ){
          return false;
        }

      }

      return true;

    });

  }

  function updateSizeUI(){

    if (!sizeGrid || sizeOptionIndex === null){
      return;
    }

    let selectedLowStock = null;

    sizeGrid
      .querySelectorAll('[data-size-button]')
      .forEach(function(button){

        const size =
          button.dataset.optionValue;

        const contextualVariant =
          getVariantForOptionValue(
            sizeOptionIndex,
            size,
            true
          );

        const anyVariant =
          getVariantForOptionValue(
            sizeOptionIndex,
            size,
            false
          );

        const exists = !!anyVariant;
        const available = !!contextualVariant;

        const active =
          selectedOptions[sizeOptionIndex] ===
          size;

        let lowStock = false;
        let quantity = null;

        if (contextualVariant){

          const stockData =
            variantInventory.get(Number(contextualVariant.id));

          if (
            stockData &&
            stockData.inventoryManagement &&
            stockData.inventoryQuantity !== null &&
            stockData.inventoryQuantity !== undefined
          ){

            quantity = Number(
              stockData.inventoryQuantity
            );

            lowStock =
              Number.isFinite(quantity) &&
              quantity > 0 &&
              quantity <= lowStockThreshold;

          }

        }

        button.classList.toggle(
          'is-active',
          active
        );
        button.setAttribute('aria-pressed', String(active));

        button.classList.toggle(
          'is-unavailable',
          !available
        );

        button.classList.toggle(
          'is-low-stock',
          lowStock
        );

        button.dataset.sizeExists =
          exists ? 'true' : 'false';

        button.dataset.sizeLowStock =
          lowStock ? 'true' : 'false';

        button.dataset.sizeQuantity =
          quantity !== null ? String(quantity) : '';

        button.disabled =
          !available && !active;

        if (active && lowStock){
          selectedLowStock = {
            size:size,
            quantity:quantity
          };
        }

      });

    const selectedLabel =
      root.querySelector('[data-size-selected]');

    if (selectedLabel){
      const selectedSize =
        selectedOptions[sizeOptionIndex];

      selectedLabel.textContent =
        selectedSize
          ? '— ' + selectedSize
          : '';
    }

    const status =
      root.querySelector('[data-size-status]');

    if (status){

      if (selectedLowStock){

        status.classList.add(
          'is-urgent'
        );

        status.innerHTML =
          '<strong>Only ' +
          selectedLowStock.quantity +
          ' pair left in EU ' +
          selectedLowStock.size +
          ' size</strong>';

      }else{

        status.classList.remove(
          'is-urgent'
        );

        status.textContent =
          window.SpoiltProductConfig.sizeNote;

      }

    }

  }

  function refreshVariantUI(){

    root
      .querySelectorAll(
        '.spoilt-shopify-option'
      )
      .forEach(function(group){

        const index =
          Number(
            group.dataset.optionIndex
          );

        group
          .querySelectorAll(
            '.spoilt-shopify-value'
          )
          .forEach(function(button){

            const value =
              button.dataset.optionValue;

            const active =
              selectedOptions[index] === value;

            const available =
              valueIsAvailable(
                index,
                value
              );

            button.classList.toggle(
              'is-active',
              active
            );

            button.classList.toggle(
              'is-unavailable',
              !available
            );

            button.disabled =
              !available && !active;

          });

        const selected =
          group.querySelector(
            '[data-option-selected]'
          );

        if (selected){

          selected.textContent =
            selectedOptions[index]
              ? '— ' +
                selectedOptions[index]
              : '';

        }

      });

    updateGradeUI();
    updateSizeUI();

  }

  /* ==========================================================
     PRICE
  ========================================================== */


  function updatePrice(
    variant
  ){

    if (!variant){

      return;

    }


    const formatted =
      formatMoney(
        variant.price
      );


    if (priceElement){

      priceElement.innerHTML =
        formatted;

    }


    if (stickyPrice){

      stickyPrice.innerHTML =
        formatted;

    }


    const addPrice =
      root.querySelector(
        '[data-add-price]'
      );


    if (addPrice){

      addPrice.innerHTML =
        formatted;

    }


    if (
      variant.compare_at_price &&
      variant.compare_at_price >
        variant.price
    ){

      if (comparePriceElement){

        comparePriceElement.innerHTML =
          formatMoney(
            variant.compare_at_price
          );

        comparePriceElement.hidden =
          false;

      }


      if (saveElement){

        saveElement.innerHTML =
          'SAVE ' +
          formatMoney(
            variant.compare_at_price -
            variant.price
          );

        saveElement.hidden =
          false;

      }

    }else{

      if (comparePriceElement){

        comparePriceElement.innerHTML =
          '';

        comparePriceElement.hidden =
          true;

      }


      if (saveElement){

        saveElement.innerHTML =
          '';

        saveElement.hidden =
          true;

      }

    }

  }


  /* ==========================================================
     AVAILABILITY
  ========================================================== */


  function updateAvailability(
    variant
  ){

    if (!variant){

      return;

    }


    const available =
      !!variant.available;


    if (addButton){

      addButton.disabled =
        !available;

    }


    if (buyButton){

      buyButton.disabled =
        !available;

    }


    if (stickyAdd){

      stickyAdd.disabled =
        !available;

    }


    if (stickyBuy){

      stickyBuy.disabled =
        !available;

    }


    const addLabel =
      root.querySelector(
        '[data-add-label]'
      );


    if (addLabel){

      addLabel.textContent =
        available
          ? window.SpoiltProductConfig.addToCartText
          : 'Sold out';

    }


  }


  /* ==========================================================
     BUNDLE
  ========================================================== */


  function updateBundle(){

    const bundle =
      root.querySelector(
        '[data-bundle]'
      );

    if (!bundle || !currentVariant){
      return;
    }

    const mainPrice =
      Number(currentVariant.price || 0);

    const mainPriceElement =
      bundle.querySelector('[data-bundle-main-price]');

    if (mainPriceElement){
      mainPriceElement.textContent =
        formatMoney(mainPrice);
    }

    const mainDetail =
      bundle.querySelector('[data-bundle-main-detail]');

    if (mainDetail){

      let sizeValue = null;

      for (let i = 0; i < selectedOptions.length; i++){

        const value = selectedOptions[i];

        if (
          value &&
          /^[0-9]+$/.test(String(value))
        ){
          sizeValue = value;
          break;
        }
      }

      mainDetail.textContent =
        sizeValue
          ? 'This item · Size ' + sizeValue
          : 'This item';
    }

    let total = mainPrice;
    let compareTotal = mainPrice;
    let itemCount = 1;
    let saving = 0;

    bundle
      .querySelectorAll('[data-bundle-addon]')
      .forEach(function(input){

        const item =
          input.closest('[data-bundle-item]');

        if (!item){
          return;
        }

        const originalPrice =
          Number(item.dataset.price || 0);

        const discountPrice =
          Math.round(originalPrice * 0.8);

        const savingForItem =
          Math.max(
            0,
            originalPrice - discountPrice
          );

        const originalPriceElement =
          item.querySelector('[data-bundle-original-price]');

        if (originalPriceElement){
          originalPriceElement.textContent =
            formatMoney(originalPrice);
        }

        const discountPriceElement =
          item.querySelector('[data-bundle-discount-price]');

        if (discountPriceElement){
          discountPriceElement.textContent =
            '+' + formatMoney(discountPrice);
        }

        if (!input.checked){
          return;
        }

        total += discountPrice;
        compareTotal += originalPrice;
        saving += savingForItem;
        itemCount++;

      });

    const totalElement =
      bundle.querySelector('[data-bundle-total]');

    if (totalElement){
      totalElement.textContent =
        formatMoney(total);
    }

    const countElement =
      bundle.querySelector('[data-bundle-count]');

    if (countElement){
      countElement.textContent =
        itemCount +
        (itemCount === 1 ? ' item' : ' items');
    }

    const wasElement =
      bundle.querySelector('[data-bundle-was]');

    if (
      wasElement &&
      compareTotal > total
    ){
      wasElement.hidden = false;
      wasElement.textContent =
        formatMoney(compareTotal);
    }else if (wasElement){
      wasElement.hidden = true;
      wasElement.textContent = '';
    }

    const savingElement =
      bundle.querySelector('[data-bundle-saving]');

    if (savingElement){
      savingElement.textContent =
        'Total savings ' + formatMoney(saving);
    }

  }


  /* ==========================================================
     APPLY VARIANT
  ========================================================== */


  function applyVariant(
    variant
  ){

    if (!variant){

      return;

    }


    currentVariant =
      variant;


    selectedOptions = [

      variant.option1 || null,

      variant.option2 || null,

      variant.option3 || null

    ];


    if (variantInput){

      variantInput.value =
        variant.id;

    }


    updatePrice(
      variant
    );


    updateAvailability(
      variant
    );


    refreshVariantUI();


    updateBundle();


    const url =
      new URL(
        window.location.href
      );


    url.searchParams.set(
      'variant',
      variant.id
    );


    window.history.replaceState(
      {},
      '',
      url.toString()
    );

  }


  /* ==========================================================
     VARIANT BUTTON CLICK
  ========================================================== */

  root
    .querySelectorAll(
      '.spoilt-shopify-value, [data-grade-button], [data-size-button]'
    )
    .forEach(function(button){

      button.addEventListener(
        'click',
        function(){

          if (button.disabled){
            return;
          }

          const isMetaGradeButton =
            button.matches('[data-grade-button]');

          if (
            isMetaGradeButton &&
            gradeOptionIndex === null
          ){
            return;
          }

          const index =
            Number(
              button.dataset.optionIndex
            );

          selectedOptions[index] =
            button.dataset.optionValue;

          let variant =
            findVariant();

          if (!variant){

            variant =
              variants.find(function(candidate){

                if (!candidate.available){
                  return false;
                }

                for (
                  let i = 0;
                  i < productOptions.length;
                  i++
                ){

                  if (
                    selectedOptions[i] &&
                    selectedOptions[i] !==
                      variantOption(
                        candidate,
                        i
                      )
                  ){
                    return false;
                  }

                }

                return true;

              });

          }

          if (variant){
            applyVariant(variant);
          }else{
            refreshVariantUI();
          }

        }
      );

    });

  /* ==========================================================
     COLOUR TOOLTIP
  ========================================================== */


  root
    .querySelectorAll(
      '[data-colour-product]'
    )
    .forEach(
      function(button){

        button.addEventListener(
          'mouseenter',
          function(){

            const label =
              root.querySelector(
                '[data-colour-label]'
              );


            if (label){

              label.textContent =
                '— ' +
                button.dataset.colourName;

            }

          }
        );

      }
    );


  /* ==========================================================
     QUANTITY
  ========================================================== */


  function setQuantity(
    value
  ){

    value =
      Math.max(
        1,
        parseInt(
          value,
          10
        ) || 1
      );


    if (quantityInput){

      quantityInput.value =
        value;

    }


    if (quantityDisplay){

      quantityDisplay.textContent =
        value;

    }

  }


  const minus =
    root.querySelector(
      '[data-qty-minus]'
    );


  const plus =
    root.querySelector(
      '[data-qty-plus]'
    );


  if (minus){

    minus.addEventListener(
      'click',
      function(){

        setQuantity(

          Number(
            quantityInput.value
          ) - 1

        );

      }
    );

  }


  if (plus){

    plus.addEventListener(
      'click',
      function(){

        setQuantity(

          Number(
            quantityInput.value
          ) + 1

        );

      }
    );

  }


  /* ==========================================================
     AJAX CART
  ========================================================== */


  async function addItems(
    items
  ){

    const rootUrl =
      (
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
      )
        ? window.Shopify.routes.root
        : '/';

    if (
      window.customElements &&
      typeof window.customElements.whenDefined === 'function'
    ){
      try{
        await window.customElements.whenDefined('cart-drawer');
      }catch(error){
        console.warn('SPOILT cart-drawer readiness:', error);
      }
    }

    const drawer =
      document.querySelector('cart-drawer');

    const notification =
      document.querySelector('cart-notification');

    let sections = [];

    if (
      drawer &&
      typeof drawer.getSectionsToRender === 'function'
    ){
      sections = drawer
        .getSectionsToRender()
        .map(function(section){
          return section && section.id
            ? section.id
            : null;
        })
        .filter(Boolean);
    }

    /* Always request the two pieces needed to refresh the normal Dawn cart UI. */
    if (sections.indexOf('cart-drawer') === -1){
      sections.push('cart-drawer');
    }

    if (sections.indexOf('cart-icon-bubble') === -1){
      sections.push('cart-icon-bubble');
    }

    if (
      notification &&
      typeof notification.getSectionsToRender === 'function'
    ){
      notification
        .getSectionsToRender()
        .forEach(function(section){
          if (
            section &&
            section.id &&
            sections.indexOf(section.id) === -1
          ){
            sections.push(section.id);
          }
        });
    }

    const formData = new FormData();

    items.forEach(function(item, index){

      formData.append(
        'items[' + index + '][id]',
        String(item.id)
      );

      formData.append(
        'items[' + index + '][quantity]',
        String(item.quantity || 1)
      );

      if (item.properties){

        Object.keys(item.properties).forEach(function(key){

          formData.append(
            'items[' + index + '][properties][' + key + ']',
            String(item.properties[key])
          );

        });

      }

    });

    formData.append(
      'sections',
      sections.join(',')
    );

    formData.append(
      'sections_url',
      window.location.pathname
    );

    const response =
      await fetch(
        rootUrl + 'cart/add.js',
        {
          method:'POST',
          headers:{
            'Accept':'application/json',
            'X-Requested-With':'XMLHttpRequest'
          },
          body:formData
        }
      );

    const data =
      await response.json();

    if (!response.ok || data.status){
      throw new Error(
        data.description ||
        data.message ||
        'Unable to add item to cart.'
      );
    }

    /* renderContents uses the product id when updating the cart drawer state. */
    if (
      (!data.id || !Number(data.id)) &&
      data.items &&
      data.items.length
    ){
      data.id = data.items[0].product_id;
    }

    if (
      drawer &&
      data.sections &&
      typeof drawer.renderContents === 'function'
    ){
      drawer.renderContents(data);
    }else if (
      drawer &&
      typeof drawer.open === 'function'
    ){
      /* The item is already in cart; open the drawer if the custom renderer is unavailable. */
      drawer.open();
    }else if (
      notification &&
      data.sections &&
      typeof notification.renderContents === 'function'
    ){
      notification.renderContents(data);
    }

    /* Refresh theme listeners so cart count/bubble and other cart UI stay in sync. */
    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles:true,
          detail:data
        }
      )
    );

    if (
      typeof window.publish ===
      'function'
    ){

      window.publish(
        'cart-update',
        {
          source:'spoilt-product'
        }
      );

    }

    return data;

  }

  /* ==========================================================
     ADD TO CART
  ========================================================== */


  form.addEventListener(
    'submit',
    async function(event){

      event.preventDefault();


      if (
        !currentVariant ||
        !currentVariant.available
      ){

        return;

      }


      try{

        if (addButton){

          addButton.disabled =
            true;

        }


        await addItems([

          {
            id:
              currentVariant.id,

            quantity:
              Number(
                quantityInput.value
              ) || 1
          }

        ]);


        showToast(
          'Added to cart'
        );


      }catch(error){

        console.error(
          'SPOILT cart error:',
          error
        );


        showToast(

          error.message ||
          'Could not add this item.'

        );

      }finally{

        updateAvailability(
          currentVariant
        );

      }

    }
  );


  /* ==========================================================
     BUY NOW
  ========================================================== */


  if (buyButton){

    buyButton.addEventListener(
      'click',
      function(){

        if (
          !currentVariant ||
          !currentVariant.available
        ){

          return;

        }


        const quantity =
          Number(
            quantityInput.value
          ) || 1;


        window.location.href =
          '/cart/' +
          currentVariant.id +
          ':' +
          quantity +
          '?return_to=/checkout';

      }
    );

  }


  /* ==========================================================
     BUNDLE
  ========================================================== */


  const bundleButton =
    root.querySelector(
      '[data-bundle-submit]'
    );


  if (bundleButton){

    bundleButton.addEventListener(
      'click',
      async function(){

        if (
          !currentVariant ||
          !currentVariant.available
        ){

          showToast(
            'Select an available variant first.'
          );

          return;
        }

        const items = [
          {
            id: currentVariant.id,
            quantity:
              Number(
                quantityInput.value
              ) || 1
          }
        ];

        const bundle =
          root.querySelector('[data-bundle]');

        const discountCode =
          bundle
            ? bundle.dataset.bundleDiscountCode
            : '';

        root
          .querySelectorAll('[data-bundle-addon]')
          .forEach(
            function(input){

              if (!input.checked){
                return;
              }

              const item =
                input.closest('[data-bundle-item]');

              if (!item){
                return;
              }

              const variantId =
                Number(item.dataset.variantId);

              if (variantId){

                items.push({
                  id: variantId,
                  quantity: 1,
                  properties:{
                    '_spoilt_bundle':
                      '20% off bundle addon'
                  }
                });

              }

            }
          );

        try{

          bundleButton.disabled = true;
          bundleButton.textContent = 'Adding…';

          await addItems(items);

          bundleButton.textContent = 'Added';

          showToast(
            items.length > 1
              ? 'Complete set added to cart'
              : 'Added to cart'
          );

          if (discountCode){

            const rootUrl =
              (
                window.Shopify &&
                window.Shopify.routes &&
                window.Shopify.routes.root
              )
                ? window.Shopify.routes.root
                : '/';

            window.location.href =
              rootUrl +
              'discount/' +
              encodeURIComponent(
                discountCode
              ) +
              '?redirect=' +
              encodeURIComponent(
                '/checkout'
              );

            return;
          }

          setTimeout(
            function(){

              bundleButton.textContent =
                'Add bundle';

              bundleButton.disabled =
                false;

            },
            1600
          );

        }catch(error){

          console.error(
            'SPOILT bundle error:',
            error
          );

          showToast(
            error.message ||
            'Could not add bundle.'
          );

          bundleButton.textContent =
            'Add bundle';

          bundleButton.disabled =
            false;

        }

      }
    );

  }


  root
    .querySelectorAll(
      '[data-bundle-addon]'
    )
    .forEach(
      function(input){

        input.addEventListener(
          'change',
          updateBundle
        );

      }
    );


  /* ==========================================================
     STICKY
  ========================================================== */


  if (stickyAdd){

    stickyAdd.addEventListener(
      'click',
      function(){

        if (addButton){

          addButton.click();

        }

      }
    );

  }


  if (stickyBuy){

    stickyBuy.addEventListener(
      'click',
      function(){

        if (buyButton){

          buyButton.click();

        }

      }
    );

  }


  /* ==========================================================
     IMAGE GALLERY + IMAGE MODAL
  ========================================================== */

  const imageModal =
    root.querySelector('[data-modal="image"]');

  const modalImage =
    root.querySelector('[data-modal-image]');

  const galleryImages =
    root.querySelectorAll('[data-gallery-image]');


  const modalGallery = Array.from(new Map(Array.from(galleryImages, function(button){
    const image = button.querySelector('img');
    return [Number(button.dataset.imageIndex), {
      index: Number(button.dataset.imageIndex),
      src: button.dataset.imageSrc,
      alt: image ? image.alt : window.SpoiltProductConfig.productTitle
    }];
  })).values()).sort(function(a, b){ return a.index - b.index; });
  let modalIndex = 0;
  let modalReturnFocus = null;
  let modalBodyOverflow = '';
  const imageCount = root.querySelector('[data-image-count]');
  const imageNavigation = root.querySelectorAll('[data-image-prev], [data-image-next]');
  imageNavigation.forEach(function(button){
    button.hidden = modalGallery.length < 2;
    button.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      navigateModal(button.hasAttribute('data-image-next') ? 1 : -1);
    });
  });
  function navigateModal(direction){
    if (!modalGallery.length || !imageModal.classList.contains('is-visible')) return;
    const position = (modalIndex + direction + modalGallery.length) % modalGallery.length;
    syncGallery(modalGallery[position].index, null, true);
  }
  if (imageModal){
    imageModal.addEventListener('keydown', function(event){
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight'){
        event.preventDefault();
        navigateModal(event.key === 'ArrowRight' ? 1 : -1);
      }
      if (event.key === 'Tab'){
        const buttons = Array.from(imageModal.querySelectorAll('button:not([hidden]):not([disabled])'));
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first){
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last){
          event.preventDefault();
          first.focus();
        }
      }
    });
    let touchStart = null;
    modalImage.addEventListener('touchstart', function(event){
      touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
    }, {passive:true});
    modalImage.addEventListener('touchend', function(event){
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) navigateModal(dx < 0 ? 1 : -1);
    }, {passive:true});
    modalImage.addEventListener('touchcancel', function(){ touchStart = null; }, {passive:true});
  }

  const featureMain =
    root.querySelector('[data-feature-main]');

  const featureMainImage =
    root.querySelector('[data-feature-main-image]');

  const mobileMain =
    root.querySelector('[data-mobile-main]');

  const mobileMainImage =
    root.querySelector('[data-mobile-main-image]');

  const featureThumbs =
    root.querySelectorAll('[data-feature-thumb]');

  const mobileThumbs =
    root.querySelectorAll('[data-mobile-thumb]');

  const galleryWrap =
    root.querySelector('.spoilt-gallery-wrap');

  function setGalleryStickyTop(){
    if (!galleryWrap) return;

    if (window.matchMedia('(max-width:760px)').matches){
      galleryWrap.style.removeProperty('--spoilt-gallery-sticky-top');
      return;
    }

    const top = galleryWrap.getBoundingClientRect().top;
    galleryWrap.style.setProperty(
      '--spoilt-gallery-sticky-top',
      Math.max(0, Math.round(top)) + 'px'
    );
  }

  function preloadGalleryImages(){
    /* Cache only the next few full-size photos so clicking through the
       gallery still feels instant, without forcing every photo on the
       product to download before the visitor has asked for it. */
    const urls = [];

    galleryImages.forEach(function(button){
      const src = button.dataset.imageSrc;
      if (src && urls.indexOf(src) === -1) urls.push(src);
    });

    urls.slice(0, 4).forEach(function(src){
      const image = new Image();
      image.decoding = 'async';
      image.src = src;
    });
  }

  const scheduleWhenIdle =
    window.requestIdleCallback ||
    function(callback){ return setTimeout(callback, 1500); };

  requestAnimationFrame(function(){
    setGalleryStickyTop();
  });

  scheduleWhenIdle(preloadGalleryImages);

  window.addEventListener('resize', function(){
    requestAnimationFrame(setGalleryStickyTop);
  });

  function closeModal(modal){
    if (!modal){
      return;
    }

    const wasOpen = modal.classList.contains('is-visible');
    modal.classList.remove('is-visible');
    modal.setAttribute('aria-hidden','true');
    if (modal === imageModal && wasOpen){
      document.body.style.overflow = modalBodyOverflow;
      if (modalReturnFocus && modalReturnFocus.isConnected) modalReturnFocus.focus({preventScroll:true});
    }
  }

  root.querySelectorAll('[data-open-modal]').forEach(function(button){
    button.addEventListener('click', function(event){
      event.preventDefault();

      const modalName = button.getAttribute('data-open-modal');
      const modal = root.querySelector('[data-modal="' + modalName + '"]');

      if (!modal){
        return;
      }

      modal.classList.add('is-visible');
      modal.setAttribute('aria-hidden','false');
    });
  });

  root.querySelectorAll('.spoilt-modal').forEach(function(modal){
    modal.querySelectorAll('[data-close-modal]').forEach(function(button){
      button.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        closeModal(modal);
      });
    });

    modal.addEventListener('click', function(event){
      if (event.target === modal){
        closeModal(modal);
      }
    });
  });

  function syncGallery(index, sourceButton, openModal){
    const target = modalGallery.find(function(image){
      return image.index === Number(index);
    });

    if (!target) return;

    const src = target.src;
    const alt = target.alt;

    if (featureMain && featureMainImage){
      featureMain.dataset.imageIndex = String(index);
      featureMain.dataset.imageSrc = src;
      featureMainImage.src = src;
      featureMainImage.alt = alt;
    }

    if (mobileMain && mobileMainImage){
      mobileMain.dataset.imageIndex = String(index);
      mobileMain.dataset.imageSrc = src;
      mobileMainImage.src = src;
      mobileMainImage.alt = alt;
    }

    featureThumbs.forEach(function(button){
      button.classList.toggle(
        'is-active',
        Number(button.dataset.imageIndex) === Number(index)
      );
    });

    mobileThumbs.forEach(function(button){
      const active = Number(button.dataset.imageIndex) === Number(index);
      button.classList.toggle('is-active', active);
      if (active && button.scrollIntoView && !openModal){
        button.scrollIntoView({behavior:'smooth', block:'nearest', inline:'center'});
      }
    });

    if (openModal && imageModal && modalImage){
      const wasOpen = imageModal.classList.contains('is-visible');
      if (!wasOpen){
        modalReturnFocus = sourceButton || document.activeElement;
        modalBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      modalIndex = modalGallery.findIndex(function(image){ return image.index === Number(index); });
      modalImage.src = src;
      modalImage.alt = alt;
      if (imageCount) imageCount.textContent = (modalIndex + 1) + ' / ' + modalGallery.length;
      imageModal.classList.add('is-visible');
      imageModal.setAttribute('aria-hidden','false');
      if (!wasOpen) imageModal.querySelector('[data-close-modal]').focus({preventScroll:true});
    }
  }

  galleryImages.forEach(function(button){
    button.addEventListener('click', function(){
      const index = Number(button.dataset.imageIndex || 0);
      const isThumbnail =
        button.hasAttribute('data-feature-thumb') ||
        button.hasAttribute('data-mobile-thumb');

      syncGallery(index, button, !isThumbnail);
    });
  });

  /* ==========================================================
     PRODUCT VIDEO — SMALL VERTICAL POPUP
  ========================================================== */

  const videoPip = root.querySelector('[data-video-pip]');

  if (videoPip){
    const pipVideo = videoPip.querySelector('video');
    const videoClose = videoPip.querySelector('[data-video-close]');
    const videoFullscreen = videoPip.querySelector('[data-video-fullscreen]');
    const videoMinimize = videoPip.querySelector('[data-video-minimize]');
    const videoPlay = videoPip.querySelector('[data-video-play]');
    const videoProgress = videoPip.querySelector('[data-video-progress]');
    const videoMute = videoPip.querySelector('[data-video-mute]');

    let closeAfterFullscreen = false;
    let videoControlFadeTimer = null;

    function isVideoFullscreen(){
      return document.fullscreenElement === videoPip || document.webkitFullscreenElement === videoPip;
    }

    function updateVideoUi(){
      if (!pipVideo){
        return;
      }

      const duration = pipVideo.duration;
      const current = pipVideo.currentTime || 0;

      if (videoProgress){
        videoProgress.value = duration > 0 ? String((current / duration) * 100) : '0';
      }

      if (videoPlay){
        videoPlay.textContent = pipVideo.paused ? '▶' : '❚❚';
        videoPlay.setAttribute('aria-label', pipVideo.paused ? 'Play video' : 'Pause video');
      }

      if (videoMute){
        const muted = pipVideo.muted || pipVideo.volume === 0;
        videoMute.textContent = muted ? '⌁' : '◖';
        videoMute.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      }

      if (videoFullscreen){
        videoFullscreen.setAttribute('aria-label', isVideoFullscreen() ? 'Exit fullscreen' : 'Open video fullscreen');
      }
    }

    function showVideoControl(keepVisible){
      if (!videoPip){
        return;
      }

      if (videoControlFadeTimer){
        clearTimeout(videoControlFadeTimer);
        videoControlFadeTimer = null;
      }

      videoPip.classList.add('is-video-control-visible');

      if (!keepVisible){
        videoControlFadeTimer = setTimeout(function(){
          if (pipVideo && !pipVideo.paused){
            videoPip.classList.remove('is-video-control-visible');
          }
          videoControlFadeTimer = null;
        }, 850);
      }
    }

    function hideVideoControl(){
      if (videoControlFadeTimer){
        clearTimeout(videoControlFadeTimer);
        videoControlFadeTimer = null;
      }

      videoPip.classList.remove('is-video-control-visible');
    }

    function hideVideo(){
      hideVideoControl();
      videoPip.classList.add('is-hidden');
      videoPip.setAttribute('aria-hidden','true');
      if (pipVideo){
        pipVideo.pause();
      }
    }

    function exitVideoFullscreen(){
      try {
        if (document.fullscreenElement && document.exitFullscreen){
          return document.exitFullscreen();
        }

        if (document.webkitFullscreenElement && document.webkitExitFullscreen){
          document.webkitExitFullscreen();
        }
      } catch (error) {}

      return Promise.resolve();
    }

    async function closeVideo(){
      if (isVideoFullscreen()){
        closeAfterFullscreen = true;

        try {
          await exitVideoFullscreen();
        } catch (error) {}

        if (!isVideoFullscreen()){
          hideVideo();
          closeAfterFullscreen = false;
        } else {
          setTimeout(function(){
            if (!isVideoFullscreen() && closeAfterFullscreen){
              hideVideo();
              closeAfterFullscreen = false;
            }
          }, 120);
        }

        return;
      }

      hideVideo();
    }

    function openVideoFullscreen(){
      closeAfterFullscreen = false;

      if (videoPip.requestFullscreen){
        try {
          const fullscreenPromise = videoPip.requestFullscreen({navigationUI:'hide'});
          if (fullscreenPromise && typeof fullscreenPromise.catch === 'function'){
            fullscreenPromise.catch(function(){
              try {
                const retryPromise = videoPip.requestFullscreen();
                if (retryPromise && typeof retryPromise.catch === 'function'){
                  retryPromise.catch(function(){});
                }
              } catch (error) {}
            });
          }
        } catch (error){
          try { videoPip.requestFullscreen(); } catch (retryError) {}
        }
        return;
      }

      if (videoPip.webkitRequestFullscreen){
        try { videoPip.webkitRequestFullscreen(); } catch (error) {}
      }
    }

    if (pipVideo){
      pipVideo.muted = true;
      pipVideo.playsInline = true;
      pipVideo.controls = false;
      pipVideo.disablePictureInPicture = true;
      pipVideo.setAttribute('playsinline','');
      pipVideo.setAttribute('webkit-playsinline','');
      pipVideo.setAttribute('disablepictureinpicture','');
      pipVideo.setAttribute('controlslist','nodownload noplaybackrate noremoteplayback');

      pipVideo.addEventListener('loadedmetadata', updateVideoUi);
      pipVideo.addEventListener('durationchange', updateVideoUi);
      pipVideo.addEventListener('timeupdate', updateVideoUi);

      pipVideo.addEventListener('play', function(){
        updateVideoUi();
        showVideoControl(false);
      });

      pipVideo.addEventListener('pause', function(){
        updateVideoUi();
        showVideoControl(true);
      });

      pipVideo.addEventListener('volumechange', updateVideoUi);

      const playPromise = pipVideo.play();
      if (playPromise && typeof playPromise.catch === 'function'){
        playPromise.catch(function(){ updateVideoUi(); });
      }
    }

    if (videoClose){
      videoClose.addEventListener('click', closeVideo);
    }

    if (videoMinimize){
      videoMinimize.addEventListener('click', function(){
        if (isVideoFullscreen()){
          closeAfterFullscreen = false;
          exitVideoFullscreen();
          return;
        }

        hideVideo();
      });
    }

    if (videoFullscreen && pipVideo){
      videoFullscreen.addEventListener('click', function(){
        if (isVideoFullscreen()){
          exitVideoFullscreen();
        } else {
          openVideoFullscreen();
        }
      });
    }

    if (videoPlay && pipVideo){
      videoPlay.addEventListener('click', function(event){
        event.stopPropagation();

        if (pipVideo.paused){
          const playPromise = pipVideo.play();
          if (playPromise && typeof playPromise.catch === 'function'){
            playPromise.catch(function(){});
          }
        } else {
          pipVideo.pause();
        }
      });
    }

    if (videoProgress && pipVideo){
      videoProgress.addEventListener('input', function(){
        if (!Number.isFinite(pipVideo.duration) || pipVideo.duration <= 0){
          return;
        }

        pipVideo.currentTime = (Number(videoProgress.value) / 100) * pipVideo.duration;
        updateVideoUi();
      });
    }

    if (videoMute && pipVideo){
      videoMute.addEventListener('click', function(){
        pipVideo.muted = !pipVideo.muted;
        if (!pipVideo.muted && pipVideo.volume === 0){
          pipVideo.volume = 1;
        }
        updateVideoUi();
      });
    }

    if (pipVideo){
      pipVideo.addEventListener('click', function(){
        if (pipVideo.paused){
          const playPromise = pipVideo.play();
          if (playPromise && typeof playPromise.catch === 'function'){
            playPromise.catch(function(){});
          }
        } else {
          pipVideo.pause();
          showVideoControl(true);
        }
      });
    }

    function handleFullscreenChange(){
      const active = isVideoFullscreen();
      root.classList.toggle('spoilt-video-fullscreen-active', active);
      updateVideoUi();

      if (!active && closeAfterFullscreen){
        closeAfterFullscreen = false;
        hideVideo();
      }
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('fullscreenerror', function(){
      closeAfterFullscreen = false;
      updateVideoUi();
    });

    updateVideoUi();
  }

  /* ==========================================================
     ACCORDIONS
  ========================================================== */


  root
    .querySelectorAll(
      '.spoilt-accordion-button'
    )
    .forEach(
      function(button){

        button.addEventListener(
          'click',
          function(){

            const accordion =
              button.closest(
                '.spoilt-accordion'
              );


            if (accordion){

              accordion.classList.toggle(
                'is-open'
              );

            }

          }
        );

      }
    );


  /* ==========================================================
     ESC
  ========================================================== */


  document.addEventListener(
    'keydown',
    function(event){

      if (
        event.key !==
        'Escape'
      ){

        return;

      }


      root
        .querySelectorAll(
          '.spoilt-modal.is-visible'
        )
        .forEach(
          function(modal){
            closeModal(modal);
          }
        );

    }
  );


  /* ==========================================================
     TOAST
  ========================================================== */


  const toast =
    root.querySelector(
      '[data-toast]'
    );


  const toastText =
    root.querySelector(
      '[data-toast-text]'
    );


  let toastTimer;


  function showToast(
    message
  ){

    if (!toast){

      return;

    }


    if (toastText){

      toastText.textContent =
        message;

    }


    toast.classList.add(
      'is-visible'
    );


    clearTimeout(
      toastTimer
    );


    toastTimer =
      setTimeout(
        function(){

          toast.classList.remove(
            'is-visible'
          );

        },
        2800
      );

  }


  /* ==========================================================
     DISPATCH COUNTDOWN
     Bangladesh time is UTC+6.
  ========================================================== */

  function getDhakaParts(date){
    const parts = new Intl.DateTimeFormat(
      'en-US',
      {
        timeZone:'Asia/Dhaka',
        year:'numeric',
        month:'2-digit',
        day:'2-digit',
        hour:'2-digit',
        minute:'2-digit',
        second:'2-digit',
        hourCycle:'h23',
        weekday:'short'
      }
    ).formatToParts(date);

    const values = {};
    parts.forEach(function(part){
      if (part.type !== 'literal'){
        values[part.type] = part.value;
      }
    });

    return values;
  }

  function dhakaWallClockToUtc(year, month, day, hour, minute, second){
    const guess = Date.UTC(year, month - 1, day, hour, minute, second);
    const probe = new Date(guess);
    const parts = getDhakaParts(probe);
    const asUtc = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );
    return new Date(guess + (guess - asUtc));
  }

  function nextDhakaDispatchCutoff(){
    const now = new Date();
    const parts = getDhakaParts(now);

    const target = dhakaWallClockToUtc(
      Number(parts.year),
      Number(parts.month),
      Number(parts.day),
      16, 0, 0
    );

    if (now.getTime() < target.getTime()){
      return target;
    }

    return dhakaWallClockToUtc(
      Number(parts.year),
      Number(parts.month),
      Number(parts.day) + 1,
      16, 0, 0
    );
  }

  function nextOverseasOrderCutoff(){
    const now = new Date();
    const parts = getDhakaParts(now);
    const weekdays = {Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6};
    const today = weekdays[parts.weekday];
    const daysUntilThursday = ((4 - today) + 7) % 7;

    return dhakaWallClockToUtc(
      Number(parts.year),
      Number(parts.month),
      Number(parts.day) + daysUntilThursday + (today === 4 ? 7 : 0),
      0, 0, 0
    );
  }

  function formatCountdown(ms){
    const totalMinutes = Math.max(0, Math.ceil(ms / 60000));
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;

    const parts = [];

    if (days > 0){
      parts.push(days + (days === 1 ? ' day' : ' days'));
    }

    if (hours > 0 || days > 0){
      parts.push(hours + (hours === 1 ? ' hour' : ' hours'));
    }

    if (minutes > 0 || (days === 0 && hours === 0)){
      parts.push(minutes + ' min');
    }

    return parts.join(' ');
  }

  function updateDispatchBar(){
    if (!dispatchBar || !dispatchCountdown){
      return;
    }

    if (stockIsOverseas){
      const cutoff = nextOverseasOrderCutoff();
      const now = Date.now();
      const nowParts = getDhakaParts(new Date());
      const weekdays = {Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6};
      const today = weekdays[nowParts.weekday];
      const thisWeek = today >= 0 && today <= 3;

      if (dispatchPrefix){
        dispatchPrefix.textContent = window.SpoiltProductConfig.overseasDispatchPrefix + ' ';
      }
      dispatchCountdown.textContent = formatCountdown(cutoff.getTime() - now);
      if (dispatchSuffix){
        dispatchSuffix.textContent = ' ' + (thisWeek
          ? window.SpoiltProductConfig.overseasDispatchSuffix
          : window.SpoiltProductConfig.overseasNextWeekSuffix);
      }

      dispatchBar.hidden = false;
      return;
    }

    if (stockIsDhaka){
      const cutoff = nextDhakaDispatchCutoff();

      if (dispatchPrefix){
        dispatchPrefix.textContent = window.SpoiltProductConfig.dhakaDispatchPrefix + ' ';
      }
      dispatchCountdown.textContent = formatCountdown(cutoff.getTime() - Date.now());
      if (dispatchSuffix){
        dispatchSuffix.textContent = ' ' + window.SpoiltProductConfig.dhakaDispatchSuffix;
      }

      dispatchBar.hidden = false;
      return;
    }

    dispatchBar.hidden = true;
  }

  function lockDeliveryOptions(){
    const activeLocation = stockIsDhaka
      ? 'dhaka'
      : stockIsOverseas
        ? 'overseas'
        : '';

    if (deliveryWrap){
      deliveryWrap.hidden = !activeLocation;
    }

    deliveryOptions.forEach(function(option){
      const radio = option.querySelector('[data-delivery-radio]');
      const location = option.dataset.deliveryOption;
      const isActive = location === activeLocation;
      const shouldDisable = !activeLocation || !isActive;

      if (radio){
        radio.disabled = shouldDisable;
        radio.checked = isActive;
      }

      option.classList.toggle('is-selected', isActive);
      option.classList.toggle('is-disabled', shouldDisable);
      option.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
    });

    if (stockProperty){
      stockProperty.value = stockIsDhaka
        ? 'Dhaka'
        : stockIsOverseas
          ? 'Overseas'
          : '';
    }
  }

  updateDispatchBar();
  setInterval(updateDispatchBar, 10000);
  lockDeliveryOptions();


  /* ==========================================================
     INHERITED CARD QUICK ADD
     Keep recommendation/main-card Quick Add on the cart drawer.
  ========================================================== */

  if (!window.SpoiltProductPageQuickAddReady){
    window.SpoiltProductPageQuickAddReady = true;

    document.addEventListener(
      'click',
      async function(event){

        const button =
          event.target.closest('[data-quick-add]');

        if (
          !button ||
          button.disabled ||
          button.dataset.spoiltHandled === 'true'
        ){
          return;
        }

        /* Only intercept the inherited cards rendered on this product page. */
        const card =
          button.closest('.custom-product-card');

        if (!card){
          return;
        }

        const variantId =
          Number(button.dataset.variantId);

        if (!variantId){
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        button.dataset.spoiltHandled = 'true';

        const originalText =
          button.textContent.trim();

        button.classList.add('is-loading');
        button.textContent = 'Adding...';

        try{

          await addItems([
            {
              id:variantId,
              quantity:1
            }
          ]);

          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = 'Added ✓';

          setTimeout(function(){
            button.classList.remove('is-added');
            button.textContent = originalText;
          }, 1400);

        }catch(error){

          console.error(
            'SPOILT card cart error:',
            error
          );

          button.classList.remove('is-loading');
          button.textContent = 'Try Again';

          setTimeout(function(){
            button.textContent = originalText;
          }, 1400);

        }finally{
          delete button.dataset.spoiltHandled;
        }

      },
      true
    );
  }

  /* ==========================================================
     RELATED PRODUCT RECOMMENDATIONS
  ========================================================== */

  function loadRecommendations(){
    const recommendationSection =
      root.querySelector('[data-recommendations-section]');

    if (!recommendationSection){
      return;
    }

    const url = recommendationSection.dataset.url;

    if (!url || recommendationSection.dataset.loaded === 'true'){
      return;
    }

    fetch(url, {headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(response){
        if (!response.ok){
          throw new Error('Recommendation request failed.');
        }
        return response.text();
      })
      .then(function(html){
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const incomingGrid =
          doc.querySelector('[data-recommendations-section] [data-recommendations-grid]');
        const localGrid =
          recommendationSection.querySelector('[data-recommendations-grid]');

        if (!incomingGrid || !localGrid || !incomingGrid.children.length){
          recommendationSection.hidden = true;
          return;
        }

        localGrid.innerHTML = incomingGrid.innerHTML;
        recommendationSection.dataset.loaded = 'true';
      })
      .catch(function(){
        recommendationSection.hidden = true;
      });
  }

  loadRecommendations();


  /* ==========================================================
     INITIAL
  ========================================================== */


  if (currentVariant){

    applyVariant(
      currentVariant
    );

  }


  updateBundle();


})();
